"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyTaxConfigurationBase = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
class CurrencyTaxConfigurationBase {
}
__decorate([
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 32,
    }),
    __metadata("design:type", String)
], CurrencyTaxConfigurationBase.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Currency Symbol' }),
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 3,
        nullable: false,
    }),
    __metadata("design:type", String)
], CurrencyTaxConfigurationBase.prototype, "currencySymbol", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'VAT Rate' }),
    (0, typeorm_1.Column)({
        type: 'float4',
        nullable: false,
    }),
    __metadata("design:type", Number)
], CurrencyTaxConfigurationBase.prototype, "vatRate", void 0);
exports.CurrencyTaxConfigurationBase = CurrencyTaxConfigurationBase;
//# sourceMappingURL=currency-tax-configuration-base.js.map